import { ListnerEvent } from "src/app/common/services";

export const costcoJoinLink: ListnerEvent = {
    id: 'costcoJoinLink',
    domElementId: 'citi-costco-anywhere-visa-credit-card__join-costco-today',
    isDomListner: true,
    domEventType: 'click'
}

export const costcoRewardsSectionJoinLink: ListnerEvent = {
    id: 'costcoRewardsSectionJoinLink',
    domElementId: 'citi-costco-anywhere-visa-credit-card__rewards-section__join-costco-today',
    isDomListner: true,
    domEventType: 'click'
}
    
export const costcoBusinessJoinLink: ListnerEvent = {
    id: 'costcoBusinessJoinLink',
    domElementId: 'citi-costco-anywhere-visa-business-credit-card__join-costco-today',
    isDomListner: true,
    domEventType: 'click'
}

export const costcoBusinessRewardsSectionJoinLink: ListnerEvent = {
    id: 'costcoBusinessRewardsSectionJoinLink',
    domElementId: 'citi-costco-anywhere-visa-business-credit-card__rewards-section__join-costco-today',
    isDomListner: true,
    domEventType: 'click'
}

export const exitLink: ListnerEvent = {
    id: 'exitLink',
    domElementId: 'citi-sign-on-to-manage-your-account',
    isDomListner: true,
    domEventType: 'click'
}

export const wayfairAccountexitLinkSection1: ListnerEvent = {
    id: 'wayfairAccountexitLink',
    domElementId: 'citi-wayfair-account-benefit-section-1',
    isDomListner: true,
    domEventType: 'click'
}

export const wayfairAccountexitLinkSection2: ListnerEvent = {
    id: 'wayfairAccountexitLinkSection2',
    domElementId: 'citi-wayfair-account-benefit-section-2',
    isDomListner: true,
    domEventType: 'click'
}

export const benefitSectionNewTabLink0: ListnerEvent = {
    id: 'benefitSectionNewTabLink0',
    domElementId: 'mkt-0-tab-0',
    isDomListner: true,
    domEventType: 'click'
}

export const benefitSectionNewTabLink1: ListnerEvent = {
    id: 'benefitSectionNewTabLink1',
    domElementId: 'mkt-0-tab-1',
    isDomListner: true,
    domEventType: 'click'
}

export const benefitSectionNewTabLink2: ListnerEvent = {
    id: 'benefitSectionNewTabLink2',
    domElementId: 'mkt-0-tab-2',
    isDomListner: true,
    domEventType: 'click'
}

    